module.exports = __webpack_public_path__ + "static/1-Tri-06-73bdc55b544c4f358c8c7aeb26163151.png";